import React, { FC, useContext, useEffect } from 'react';
import DeleteList from 'Components/SmartList/DeleteList';
import UserDetailsContext from 'Context/userDetailsContext';
import { useDispatch } from 'react-redux';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useMutation } from '@apollo/react-hooks';
import { toastMessage } from 'Containers/Toast/actions';
import { useHistory } from 'Utils/router';
import withErrorBoundary from 'HOC/ErrorBoundary';
// eslint-disable-next-line camelcase
import { DeleteList_GQL } from './gqlQuery';

interface Props {
  listName?: string;
  id: string;
  closeModal?: () => void;
}

const DeleteListContainer: FC<Props> = (props: Props) => {
  const Dispatch = useDispatch();
  const userDetails = useContext(UserDetailsContext);
  const [deleteList, { loading, error, data }] = useMutation(DeleteList_GQL);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const history = useHistory();
  const { listName, id, closeModal } = props;

  useEffect(() => {
    if (data) {
      if (data.listDelete.code >= 200 && data.listDelete.code <= 299) {
        // Currently there is no pagination on list, use console to verify save //
        Dispatch(
          toastMessage({
            message: `<i>${listName}</i> has been deleted successfully`,
            position: 'bottom',
          })
        );
        closeModal();
      }
    }
  }, [data]);

  const onDeleteHandler = () => {
    deleteList({
      variables: {
        inst_id: userDetails.instId,
        account_id: userDetails.accountId,
        id,
      },
    });
  };

  return (
    <DeleteList
      errorMessage={error ? error.message : null}
      name={listName}
      onCancel={closeModal}
      onDelete={() => onDeleteHandler()}
      disabled={!!(loading || data)}
    />
  );
};

DeleteListContainer.defaultProps = {
  listName: '',
  closeModal: () => {},
};

export default withErrorBoundary(DeleteListContainer);
